Shopify.queryParams = {};

if (location.search.length) {
	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
		aKeyValue = aCouples[i].split('=');
		if (aKeyValue.length > 1) {
			Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
		}
	}
}

class ShopifyFiltering {
	constructor(filterEl) {
		this.filterEl = filterEl;
		this.registerEvents();
	}

	registerEvents() {
		$('body').on('change', '#sort-by', this.handleFilterSelection.bind(this));
	}

	handleFilterSelection() {
		Shopify.queryParams.sort_by = this.filterEl.val();

		const destinationUrl = this.buildDestinationUrl(this.getQueryString());

		this.updateView(destinationUrl);
	}

	getQueryString() {
		let query = '?' + $.param(Shopify.queryParams);
		return query.replace(/\page=(\w+)&/, '');
	}

	buildDestinationUrl(query) {
		const url = window.location.href.split('?')[0];
		return url + query;
	}

	updateView(url) {
		$.ajax({
			type: 'GET',
			url: url,
			beforeSend: function() {
				$(".collection-grid").addClass('loading');
			},
			success: function(data) {
				$('.collection-grid').removeClass('loading');

				var filteredPagination = $(data).find('.paginate').html();
				$('.paginate').html(filteredPagination);

				var filteredSidebar = $(data).find('.sidebar').html();
				$('.sidebar').html(filteredSidebar);

				var filteredPageLinks = $(data).find('.paginate').html();
				$('.paginate').empty();
				$('.paginate').html(filteredPageLinks);

				var filteredData = $(data).find('.collection-grid');
				$('.collection-grid').remove();
				$('.archive-content-sidebar-wrapper').append(filteredData);

				window.history && window.history.pushState && window.history.pushState("", "", url);
			},
			error: () => location.replace(url),
			dataType: "html"
		});
	}
}

export default ShopifyFiltering;

